import { jsxs as r, jsx as l } from "react/jsx-runtime";
const Z = (a) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M31.999 13.627c10.229 0 18.521 8.292 18.521 18.52s-8.292 18.521-18.521 18.521c-10.229 0-18.52-8.292-18.52-18.521 0-10.229 8.292-18.52 18.52-18.52Zm0-3.996a22.444 22.444 0 0 0-15.921 6.595 22.428 22.428 0 0 0-4.824 7.156 22.367 22.367 0 0 0-1.771 8.765c0 3.037.596 5.987 1.771 8.765a22.428 22.428 0 0 0 4.824 7.156 22.428 22.428 0 0 0 7.156 4.824 22.385 22.385 0 0 0 8.765 1.771 22.444 22.444 0 0 0 15.921-6.595 22.428 22.428 0 0 0 4.824-7.156 22.367 22.367 0 0 0 1.771-8.765c0-3.037-.596-5.987-1.771-8.765a22.428 22.428 0 0 0-4.824-7.156 22.428 22.428 0 0 0-7.156-4.824 22.385 22.385 0 0 0-8.765-1.771Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M22.011 36.144a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996ZM41.988 36.144a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996ZM35.442 24.411a4.012 4.012 0 0 0 0-4.059l-2.03 2.03 2.03 2.03v-.001ZM28.557 20.351a4.012 4.012 0 0 0 0 4.059l2.03-2.03-2.03-2.03v.001ZM34.029 18.939a4.012 4.012 0 0 0-4.059 0l2.03 2.03 2.03-2.03h-.001ZM29.971 25.823a4.012 4.012 0 0 0 4.059 0L32 23.793l-2.03 2.03h.001ZM35.442 44.018a4.013 4.013 0 0 0 0-4.06l-2.03 2.03 2.03 2.03ZM28.557 39.96a4.013 4.013 0 0 0 0 4.06l2.03-2.03-2.03-2.03ZM34.029 38.546a4.012 4.012 0 0 0-4.059 0l2.03 2.03 2.03-2.03h-.001ZM29.971 45.431a4.012 4.012 0 0 0 4.059 0L32 43.401l-2.03 2.03h.001Z"
        }
      )
    ]
  }
);
export {
  Z as ChargerChademo
};
